// extracted by mini-css-extract-plugin
export default {"container":"magazineCard_container__0xLAE","card":"magazineCard_card__AqgPW","label":"magazineCard_label__JgNpx","title":"magazineCard_title__iFg2O"};